import { render, staticRenderFns } from "./SellsyInformationsSection.vue?vue&type=template&id=8c03beee&scoped=true&"
import script from "./SellsyInformationsSection.vue?vue&type=script&lang=js&"
export * from "./SellsyInformationsSection.vue?vue&type=script&lang=js&"
import style0 from "./SellsyInformationsSection.vue?vue&type=style&index=0&id=8c03beee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c03beee",
  null
  
)

export default component.exports